let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9dGnG"), load("aZDAn")]).then(() => parcelRequire('72p3J'));